import { render, staticRenderFns } from "./Calendar.vue?vue&type=template&id=918823ee"
import script from "./Calendar.vue?vue&type=script&lang=ts"
export * from "./Calendar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('918823ee')) {
      api.createRecord('918823ee', component.options)
    } else {
      api.reload('918823ee', component.options)
    }
    module.hot.accept("./Calendar.vue?vue&type=template&id=918823ee", function () {
      api.rerender('918823ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/Calendar.vue"
export default component.exports